import React from 'react';
import { Result, Button } from 'antd';
import {useNavigate} from "react-router-dom";


const NotFind = () => {
    const navigation = useNavigate();
    return(
        <Result
            status="404"
            title="404"
            subTitle="您访问的页面不存在呀！"
            extra={<Button onClick={() => navigation(-1)} type="primary">返回</Button>}
        />
    )
}

export default NotFind
